import { LOCALES, LOCALES as LOCALE } from 'i18n/locales';
import { ProfileService } from 'client/services';
import { setLocale } from 'client/store/localeSlice/localeSlice';

export const getTranslationOrEnglish = (entity, locale) => {
    return entity
        ? entity[locale] ? entity[locale] : entity[LOCALE.ENGLISH]
        : undefined;
};

/**
 * Manages the locale change, updating the user preference if they are signed in, or if they are signed out just dispatching the action.
 * @param currentLocale The current locale
 * @param isAuthenticated If the user is authenticated
 * @param dispatch The react dispatch hook
 */
export const manageLocaleChange = (currentLocale, isAuthenticated, dispatch) => {
    const newLocale = currentLocale === LOCALES.ENGLISH ? LOCALES.WELSH : LOCALES.ENGLISH;
    if (isAuthenticated) {
        ProfileService.patchPreference(newLocale);
    }
    dispatch(setLocale(newLocale));
};

export default getTranslationOrEnglish;
